
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import IComptage from "@/types/comptage.interface";
import TooltipDialog from "@/components/utils/TooltipDialog.vue";
import frontService from "@/services/front.service";
import i18n from "@/plugins/vue-i18n";

@Component({
    components: {TooltipDialog}
})
export default class GeolocationFilterComptage extends Vue {
    @Prop() readonly filters!: { geolocations: { regions; departements; villes; zip_codes } };
    @Prop() readonly product: IComptage;
    @Prop() readonly loadingFilter: boolean;
    private regions;
    private departements;
    private villes;

    private searchInput = '';

    private items = [{name: i18n.tc('loading'), property: 'loading'}];

    init() {
        if (this.items.length === 1 && this.items[0].property === 'loading') {

            if (this.filters && this.filters.geolocations) {
                const items = [
                    {header: i18n.tc('regions'), property: 'regions'},
                    ...this.filters.geolocations.regions,
                    {divider: true, property: 'regions'},
                    {header: i18n.tc('departments'), property: 'departments'},
                    ...this.filters.geolocations.departements,
                    {divider: true, property: 'departments'},
                    {header: i18n.tc('cities'), property: 'cities'},
                    ...this.filters.geolocations.villes
                ];
                this.regions = this.filters.geolocations.regions;
                this.departements = this.filters.geolocations.departements;
                this.villes = this.filters.geolocations.villes;
                this.items = items;
            }
        }
    }

    @Watch("filters", {deep: true})
    filtersChanged() {
        this.init();
    }

    created() {
        this.init();
    }

    setGeolocations(values) {
        this.$emit('set-geolocation', values);
    }

    itemText(item) {
        return frontService.geolocationDescription(item);
    }

    normalize(text) {
        return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase();
    }

    filter(item, queryText, itemText) {
        const finalQueryText = this.normalize(queryText);
        if (item.header || item.divider) {
            if (item.property === 'regions') {
                return this.regions.map(r => frontService.geolocationDescription(r)).find(r => this.normalize(r).indexOf(finalQueryText) > -1)
            } else if (item.property === 'departments') {
                return this.departements.map(r => frontService.geolocationDescription(r)).find(r => this.normalize(r).indexOf(finalQueryText) > -1)
            } else if (item.property === 'cities') {
                return this.villes.map(r => frontService.geolocationDescription(r)).find(r => this.normalize(r).indexOf(finalQueryText) > -1)
            } else {
                return false;
            }
        } else {
            return this.normalize(itemText).indexOf(queryText.toLocaleLowerCase()) > -1;
        }
    }
}
